import {
  Box,
  Typography,
  Button,
  Link,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  ThemeProvider,
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';

import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import { useStyles } from './inbody-tutorial-panel.styles';
import { generateTheme } from 'utils/helpers';

export const InbodyTutorialPanel = () => {
  const classes = useStyles();

  return (
    <ol>
      <li className={classes.listItem}>
        <Box mb={1} component="section">
          <Box className={classes.wrapper}>
            <Typography variant="h6">
              ¿Cómo realizo un análisis InBody&reg;?
            </Typography>
            {/* <Button variant="contained" size="small" color="primary">
              Ver tutorial
            </Button> */}
          </Box>
        </Box>
        <Box mb={2} component="article">
          <ThemeProvider theme={theme => generateTheme(theme, 'light')}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ArrowForwardIosIcon />}
                colo="secondary"
              >
                <Typography variant="h6" className={classes.colored}>
                  Paso 1: adquiere un pase Wellnub-InBody&reg;
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <Typography variant="h6">
                  Opción 1: A través de tu nutriólogo Wellnub
                </Typography>
                <ol className={classes.innerList}>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      Ponte en contacto con tu nutriólogo y pídele que te envié
                      un pase Wellnub-InBody®.
                    </Typography>
                  </li>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      En cuanto tu nutriólogo realice esta acción, te llegará un
                      email para notificarte que se te ha asignado un pase.
                      También podrás ver esta notificación al iniciar sesión en
                      tu perfil Wellnub en tu “Página Principal” en la sección
                      “Próximos eventos”.
                    </Typography>
                  </li>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      Una vez que tu nutriólogo te haya asignado tu pase,
                      tendrás 15 días para utilizarlo.
                    </Typography>
                  </li>
                </ol>
                <Typography variant="h6">
                  Opción 2: A través de wellnub.com
                </Typography>
                <ol className={classes.innerList}>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      Inicia sesión en tu perfil Wellnub.
                    </Typography>
                  </li>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      EN COMPUTADORA - dirígete a la sección “Configuración” que
                      se encuentra en la parte superior derecha de la barra de
                      navegación, al presionar el ícono de persona, y luego haz
                      clic/toca en “Mi Actividad”. <br />
                      EN CELULAR - dirígete a la sección “Mi Actividad” la cual
                      encontrarás al tocar el ícono con 3 líneas horizontales
                      que se encuentra a la derecha en la barra de navegación
                      color gris.
                    </Typography>
                  </li>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      En la sección “Mi Actividad” dirígete a la subsección{' '}
                      <Link
                        component={RouterLink}
                        to="/settings/activity/purchases"
                        underline="none"
                      >
                        <Typography
                          variant="h6"
                          component="span"
                          className={classes.asLink}
                        >
                          "Compras"
                        </Typography>
                      </Link>{' '}
                      y haz clic/toca en el botón “Comprar pases
                      Wellnub-InBody®”.
                    </Typography>
                  </li>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      Elige el número de pases que deseas adquirir y tu forma de
                      pago. Podrás pagar con tarjeta de débito o crédito. Los
                      pagos están respaldados por nuestro proveedor de pagos
                      CONEKTA®.
                    </Typography>
                  </li>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      Tu(s) nuevo(s) pase(s) se cargará(n) inmediatamente en tu
                      cuenta.
                    </Typography>
                  </li>
                </ol>
                <Box mt={2} ml={4}>
                  {/* ---- Accordion start */}
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ArrowForwardIosIcon />}
                      colo="secondary"
                    >
                      <Typography variant="h6">
                        Paso 1: FAQ - Vigencia de pases
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordionDetails}>
                      <Typography variant="h6">
                        ¿Los pases Wellnub-InBody® tienen vigencia?
                      </Typography>

                      <Typography variant="body2">
                        <Typography variant="h6" component="span">
                          Pases adquiridos a través de tu nutriólogo.
                        </Typography>{' '}
                        Estos pases tienen una vigencia de 15 días para que
                        agendes tu prueba Wellnub-InBody®, pasando este tiempo
                        tu pase expirará, por lo que ya no estará disponible
                        para que puedas agendar tu prueba. ¡Pero no te
                        preocupes! Si pasando los 15 días necesitas agendar un
                        análisis, comunícate nuevamente con tu nutriólogo para
                        que te asigne un nuevo pase y puedas continuar con el
                        proceso. <br />
                        <Typography variant="h6" component="span">
                          Pases adquiridos por ti mismo a través de wellnub.com.
                        </Typography>{' '}
                        Estos pases NO tienen vigencia. Podrás utilizarlos en el
                        momento que quieras.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  {/* ---- Accordion end */}
                </Box>
              </AccordionDetails>
            </Accordion>
          </ThemeProvider>
        </Box>

        <Box mb={2} component="article">
          <ThemeProvider theme={theme => generateTheme(theme, 'light')}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ArrowForwardIosIcon />}
                colo="secondary"
              >
                <Typography variant="h6" className={classes.colored}>
                  Paso 2: Usa tu pase para agendar tu análisis Wellnub-InBody®
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <ol className={classes.innerList}>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      EN COMPUTADORA: Dentro de tu perfil de Wellnub en tu
                      “Página Principal”, haz clic/toca en la opción{' '}
                      <Link
                        component={RouterLink}
                        to="/dashboard/appointment"
                        underline="none"
                      >
                        <Typography
                          variant="h6"
                          component="span"
                          className={classes.asLink}
                        >
                          "Agenda un análisis InBody&reg;"
                        </Typography>
                      </Link>{' '}
                      que se encuentra en el menú del lado izquierdo.
                      <br />
                      EN CELULAR: dirígete a la sección “Agenda un análisis
                      Wellnub-InBody®” la cual encontrarás al tocar el ícono con
                      3 rayas horizontales que se encuentra a la derecha en la
                      barra de navegación color gris.
                    </Typography>
                  </li>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      Lee los pasos que te desglosamos y haz clic/toca en el
                      botón “Comenzar”.
                    </Typography>
                  </li>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      <Typography variant="h6" component="span">
                        Paso 1 de 3 “Tus pases disponibles”.
                      </Typography>{' '}
                      Te mostraremos tu(s) pase(s) disponible(s). Si tienes
                      pases disponibles, podrás continuar al paso 2 de 3. En
                      caso de que no tengas pases disponibles o quieras adquirir
                      adicionales puedes adquirirlos a través de tu nutriólogo o
                      a través de wellnub.com (ver tutorial paso 1: adquiere un
                      pase Wellnub-InBody®).
                    </Typography>
                  </li>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      <Typography variant="h6" component="span">
                        Paso 2 de 3 “Elige la locación que mejor te convenga
                        para realizar tu análisis Wellnub-InBody®”.
                      </Typography>{' '}
                      Te mostraremos las locaciones disponibles para realizar tu
                      análisis, selecciona la que mejor te acomode. Puedes hacer
                      clic/toca directamente en el nombre de la locación para
                      ver horarios disponibles o bien, haz clic/toca en “ver
                      detalle” para conocer especificaciones de la locación que
                      deseas consultar.
                    </Typography>
                  </li>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      <Typography variant="h6" component="span">
                        Paso 3 de 3 “Revisa los horarios disponibles de la
                        locación seleccionada y confirma tu reservación”.
                      </Typography>{' '}
                      En la parte inferior verás los días y horarios disponibles
                      en la locación seleccionada. Selecciona el día y la hora
                      de tu preferencia y haz clic/toca en el botón “siguiente”.
                      Para finalizar, confirma tu reservación haciendo clic/toca
                      en el botón “Confirmar Reservación”.
                    </Typography>
                  </li>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      En la “Página Principal” de tu perfil Wellnub, podrás ver
                      tu cita agendada en la sección “Próximos eventos”. También
                      te mandaremos un correo electrónico con los detalles de tu
                      cita, indicaciones y recomendaciones para el día de tu
                      análisis Wellnub-InBody®.
                    </Typography>
                  </li>
                </ol>
              </AccordionDetails>
            </Accordion>
          </ThemeProvider>
        </Box>

        <Box mb={2} component="article">
          <ThemeProvider theme={theme => generateTheme(theme, 'light')}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ArrowForwardIosIcon />}
                colo="secondary"
              >
                <Typography variant="h6" className={classes.colored}>
                  Paso 3: Asiste a tu análisis Wellnub-InBody®
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <ol className={classes.innerList}>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      Preséntate en la locación el día y hora que seleccionaste.
                      Para brindarte la mejor atención, te pedimos por favor que
                      seas puntual.
                    </Typography>
                  </li>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      En recepción te pedirán tu nombre y los últimos 4 dígitos
                      de tu teléfono para verificar tu reservación.
                    </Typography>
                  </li>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      El staff de la locación te acompañará al equipo InBody® y
                      te solicitará de nuevo tu número celular al iniciar la
                      prueba. Si es la primera vez que te haces un análisis en
                      esa locación, te pedirán ingresar al equipo tu edad, sexo
                      y estatura.
                    </Typography>
                    <Typography variant="body2">
                      <Typography variant="h6" component="span">
                        NOTA:
                      </Typography>{' '}
                      Es muy importante que el número celular que ingreses
                      coincida con el número que ingresaste a Wellnub al momento
                      de registrarte, de otra manera, no recibirás los
                      resultados de tu análisis.
                    </Typography>
                  </li>
                </ol>
              </AccordionDetails>
            </Accordion>
          </ThemeProvider>
        </Box>

        <Box mb={2} component="article">
          <ThemeProvider theme={theme => generateTheme(theme, 'light')}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ArrowForwardIosIcon />}
                colo="secondary"
              >
                <Typography variant="h6" className={classes.colored}>
                  Paso 4: Recepción y consulta de los resultados de tu análisis
                  Wellnub-InBody®
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <ol className={classes.innerList}>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      Tus resultados InBody® estarán listos en menos de 30
                      minutos después de que hayas finalizado tu prueba. Te
                      enviaremos un email para comunicártelo.
                    </Typography>
                  </li>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      Una vez listos tus resultados, podrás consultarlos dentro
                      de tu perfil Wellnub: <br />
                      EN COMPUTADORA: en tu “Página principal”, ve al menú que
                      se encuentra del lado izquierdo y dirígete a la sección{' '}
                      <Link
                        component={RouterLink}
                        to="/dashboard/progress"
                        underline="none"
                      >
                        <Typography
                          variant="h6"
                          component="span"
                          className={classes.asLink}
                        >
                          "Mi progreso"
                        </Typography>
                      </Link>
                      <br />
                      EN CELULAR: dirígete a la sección “Mi progreso” la cual
                      encontrarás al tocar el ícono con 3 rayas horizontales que
                      se encuentra a la derecha en la barra de navegación color
                      gris.
                    </Typography>
                  </li>
                  <li className={classes.innerListItem}>
                    <Typography variant="body2">
                      En la sección “Mi Progreso” selecciona la fecha del
                      análisis que quieres consultar.
                      <br />
                      <Typography variant="h6" component="span">
                        NOTA 1:
                      </Typography>{' '}
                      Si deseas consultar un análisis InBody® con una fecha
                      anterior, debes de dirigirte al desplegable de “Fecha de
                      consulta” y seleccionar la fecha del análisis que deseas
                      consultar.
                      <br />
                      <Typography variant="h6" component="span">
                        NOTA 2:
                      </Typography>{' '}
                      Si te encuentras vinculado a un nutriólogo, él/ella
                      también recibirá los resultados de tu análisis en su
                      perfil de nutriólogo en Wellnub.
                    </Typography>
                  </li>
                </ol>
                <Box mt={2} ml={4}>
                  {/* ---- Accordion start */}
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ArrowForwardIosIcon />}
                      colo="secondary"
                    >
                      <Typography variant="h6">
                        Paso 4: FAQ - El día de la prueba
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordionDetails}>
                      <Box mb={2}>
                        <Typography variant="h6">
                          ¿Cuánto tiempo me toma el análisis InBody?
                        </Typography>

                        <Typography variant="body2">
                          ¡El análisis en el equipo InBody® es rapidísimo! dura
                          menos de 1 minuto y no es nada invasivo.
                        </Typography>
                      </Box>
                      <Box mb={2}>
                        <Typography variant="h6">
                          ¿Qué información debo compartir al presentarme a la
                          locación que elegí para hacerme el análisis
                          Wellnub-InBody®?
                        </Typography>

                        <Typography variant="body2">
                          Al recibirte en recepción te pedirán tu nombre y el
                          número de celular a 10 dígitos con el que estás
                          registrado en Wellnub para poder verificar tu
                          reservación. Además, en cuanto inicie la prueba, se te
                          solicitará de nuevo tu número celular. Adicionalmente,
                          si es la primera vez que te realizas un análisis
                          Wellnub-InBody® te pedirán ingresar tu edad, sexo y
                          estatura al iniciar tu análisis en el equipo InBody®.
                          <br />
                          <Typography variant="h6" component="span">
                            NOTA:
                          </Typography>{' '}
                          Es muy importante que el número celular que
                          proporcionees coincida con el número que ingresaste a
                          Wellnub al momento de registrarte.
                        </Typography>
                      </Box>
                      <Box mb={2}>
                        <Typography variant="h6">
                          ¿Qué sucede si por algún motivo no asisto a mi cita?
                        </Typography>

                        <Typography variant="body2">
                          Si no re-agendaste tu cita y no te presentaste el día
                          y hora estipulada, perderás ese pase y necesitarás un
                          nuevo pase para agendar otra vez tu análisis. Si estás
                          trabajando con un nutriólogo, te sugerimos contactarte
                          con tu nutriólogo/a para platicarle tu situación y
                          solicitar un nuevo pase.
                        </Typography>
                      </Box>
                      <Box mb={2}>
                        <Typography variant="h6">
                          ¿En cuánto tiempo estarán disponibles mis resultados
                          InBody®?
                        </Typography>

                        <Typography variant="body2">
                          Una vez realizado tu análisis, los resultados estarán
                          listos en menos de 30 minutos para que los consultes
                          dentro de tu perfil Wellnub. Te enviaremos un correo
                          para notificarte que tus resultados están listos.
                        </Typography>
                      </Box>
                      <Box mb={2}>
                        <Typography variant="h6">
                          ¿Hay recomendaciones para prepararme para mi análisis
                          Wellnub-InBody®?
                        </Typography>

                        <ul
                          style={{
                            marginTop: 4,
                            marginLeft: 16,
                            listStyle: 'square inside',
                          }}
                        >
                          <li>Evita bebidas/comidas 2 horas antes.</li>
                          <li>Procura acudir al baño antes de tu análisis.</li>
                          <li>Evita realizar ejercicio intenso previamente.</li>
                          <li>
                            Si pasaste mucho tiempo sentado, procura estar de
                            pie al menos 5 minutos antes de tu prueba.
                          </li>
                          <li>
                            Puedes preguntar a tu nutriólogo sobre
                            recomendaciones específicas adicionales para tener
                            un resultado más preciso.
                          </li>
                        </ul>
                      </Box>
                      <Box mb={2}>
                        <Typography variant="h6">
                          ¿El análisis Wellnub-InBody® es invasivo?
                        </Typography>

                        <Typography variant="body2">
                          No, no es invasivo. Lo único que requiere la medición
                          es que te pares sobre dos electrodos y sujetes otros
                          dos con tus manos. La corriente eléctrica es
                          imperceptible.
                        </Typography>
                      </Box>
                      <Box mb={2}>
                        <Typography variant="h6">
                          ¿El análisis Wellnub-InBody® es apto para personas con
                          marcapasos?
                        </Typography>

                        <Typography variant="body2">
                          Pacientes con marcapasos deberán evitar realizarse el
                          análisis.
                        </Typography>
                      </Box>
                      <Box mb={2}>
                        <Typography variant="h6">
                          ¿El análisis Wellnub-InBody® es apto para personas con
                          prótesis?
                        </Typography>

                        <Typography variant="body2">
                          Pacientes con prótesis pueden realizarlo sin problema,
                          únicamente considerando que el equipo InBody®
                          posiblemente detecte dicha prótesis como si fuera
                          músculo (dependiendo del tamaño, material y lugar
                          donde se ubique la prótesis).
                        </Typography>
                      </Box>
                      <Box mb={2}>
                        <Typography variant="h6">
                          ¿El análisis Wellnub-InBody® es apto para mujeres
                          embarazadas?
                        </Typography>

                        <Typography variant="body2">
                          Mujeres embarazadas pueden realizarse la prueba sin
                          riesgo alguno tanto para ellas como para su bebé.
                        </Typography>
                      </Box>
                      <Box mb={2}>
                        <Typography variant="h6">
                          ¿El análisis Wellnub-InBody® es apto para niños?
                        </Typography>

                        <Typography variant="body2">
                          Los niños se pueden hacer la prueba InBody&reg;, de
                          hecho contamos con una hoja de resultados InBody®
                          pediátrica especialmente diseñada para menores de 15
                          años.
                        </Typography>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                  {/* ---- Accordion end */}
                </Box>
              </AccordionDetails>
            </Accordion>
          </ThemeProvider>
        </Box>
      </li>
    </ol>
  );
};
